import { TimePickerLocale } from '../TimePicker';

const locale: TimePickerLocale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time'],
};

export default locale;
